declare global {
  interface Window {
    dataLayer: DataLayerObject[];
  }
}

interface DataLayerObject {
  [key: string]: string | null;
}

export const pushToDataLayer = (dataLayerObject: DataLayerObject): void => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(dataLayerObject);
  }
};
